import React, { useState } from "react";
import ArrowEdge from "./ArrowEdge";

// 定义了一组示例颜色
const COLORS = ["#FF5733", "#33FF57", "#3357FF", "#F3FF33", "#33FFF6"];

// ColorPicker组件
const ColorPicker = ({ onSelect, currentColor }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [displayColor, setDisplayColor] = useState(currentColor);
  // 处理色块选择
  const handleColorSelect = (color) => {
    onSelect(color); // 调用传入的onSelect回调函数
    setDisplayColor(color);
    setIsVisible(false); // 关闭选择器
  };

  // 渲染色块
  const renderColors = () => {
    return COLORS.map((color) => (
      <>
        <div
          key={color}
          style={{
            width: "180px",
            height: "20px",
            backgroundColor: color,
            display: "inline-block",
            margin: "0px",
            cursor: "pointer",
            border: "none",
            padding: "0",
          }}
          onClick={() => handleColorSelect(color)}
        />
        <br />
      </>
    ));
  };

  return (
    <div
      style={{
        width: "200px",
        height: "20px",
        marginTop: "15px",
      }}
    >
      <div>
        <ArrowEdge
          color={displayColor}
          onClick={() => {
            setIsVisible(!isVisible);
          }}
        />
      </div>
      {/* <div
      onClick={() => setIsVisible(!isVisible)}
      key={displayColor} 
      style={{
        width: '120px',
        height: '20px',
        backgroundColor: displayColor,
        display: 'inline-block',
        margin: '0px',
        cursor: 'pointer',
      }}> </div> */}
      {isVisible && (
        <div
          style={{
            // position: 'absolute',
            // top: '100%',
            left: 0,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            padding: "10px",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          {renderColors()}
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
